<template>
  <div>
    <div class="d-inline-flex justify-center align-center">
      <v-btn
        :disabled="vModel === parseInt(min)"
        class="brand-primary"
        color="brand-green-dark"
        icon
        @click="onDecrementClick"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>

      <div
        ref="quantity"
        class="px-2 brand-green-dark--text brand-text-title text-center text-no-select"
        style="min-width: 34px;"
      >
        <span>{{ quantity }}</span>
      </div>

      <v-btn
        :disabled="vModel === parseInt(max)"
        class="brand-primary"
        color="brand-green-dark"
        icon
        @click="onIncrementClick"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>

import ProductDialogQuantitySelectorMixin from '@/theme/default/components/product/ProductDialogQuantitySelector.js'

export default {
  name   : 'ProductDialogQuantitySelector',
  mixins : [ProductDialogQuantitySelectorMixin],
  methods: {
    triggerFlyAnimation() {
    }
  }
}
</script>

<style scoped src="@/theme/default/components/product/ProductDialogQuantitySelector.css"></style>

<style scoped>
</style>
